import setUtil from '../../../../utils/set'

function setReduxReducer (state, action) {
  const {
    path,
    paths,
    value,
    values,
    options
  } = action.payload
  if (paths) {
    return paths.reduce((updatedState, p, index) => {
      return setUtil(updatedState, p, values[index], options)
    }, state)
  }
  if (!path) {
    return {
      ...state, ...value
    }
  }
  return setUtil(state, path, value, options)
}

export default setReduxReducer
